import {BOARD_ID} from '@/util/BoardConst';

export const RESTAURANT_BOARD_ID = BOARD_ID.BID_GOLF_RESTAURANT_RECOMMEND;
